module.exports = __webpack_public_path__ + "img/branch-biddings.734f1a58.png";